import styled from 'styled-components'

export const LoginWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};
  height: 100%;
  overflow: auto;
`

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: red;
  height: 880px;
  width: 606px;
  background: #f9f9f9;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  overflow: hidden;

  header {
    h2 {
      color: ${({ theme }) => theme.colors.sandy}${({ theme }) => theme.colors.sandy};
      text-align: center;
    }

    img {
      display: block;
      width: 240px;
      margin: 0 auto;
    }
  }

  section.buttons {
    justify-self: flex-end;

    margin-top: ${({ theme }) => theme.spacings[14]};

    width: 50%;

    p {
      text-align: center;
    }

    button {
      display: block;
      margin: 0 auto;
    }

    button + button,
    button + p,
    p + button,
    p + p {
      margin-top: ${({ theme }) => theme.spacings[4]};
    }
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 50%;

    margin: ${({ theme }) => `${theme.spacings[10]} auto ${theme.spacings[2]}`};

    button + button {
      margin-top: ${({ theme }) => theme.spacings[7]};
    }
  }
`

export const HeaderForm = styled.div`
  position: relative;
  height: 50%;
  width: 100%;
  border-radius: 32px 32px 0px 0px;
  background: ${({ theme }) => theme.colors.primary};
`

export const DataForm = styled.div`
  padding: 50px 70px;
  z-index: 1;
  height: 50%;
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
`

export const ForgetPasswordLink = styled.button`
  font-family: ${({ theme }) => theme.fonts.arial};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.secondary};
  background-color: transparent;
  width: 100%;
  text-align: right;
  transition: 0.3s;
  padding: 8px 0;

  &:focus {
    z-index: 1;
    box-shadow: 0 0 0 1px ${(props) => props.theme.colors.secondary};
    border-color: ${(props) => props.theme.colors.secondary};
  }

  :hover {
    filter: brightness(90%);
    text-decoration: underline;
  }
`

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100%;

  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.colors.white} 0 48%, ${theme.colors.deepSeaBlue} 45%, ${theme.colors.twilightBlue})`};

  img {
    display: block;

    max-height: 70vh;
    max-width: 70%;
    /* width: 460px; */

    /* margin-left: 20%; */
  }
`

export const HeaderImageContainer = styled.div`
  margin-top: 50px;
  margin-left: 24px;
`

interface PointsProps {
  top: boolean
}

export const PointsContainer = styled.div<PointsProps>`
  position: absolute;
  z-index: 1;
  top: ${(props) => props.top && '1%'};
  bottom: ${(props) => !props.top && '1%'};
  left: ${(props) => props.top && '52%'};
  right: ${(props) => !props.top && '52%'};
`

export const LogoContainer = styled.div`
  position: absolute;
  top: 300px;
  right: 25px;
`

export const LoginTextContainer = styled.div`
  position: absolute;
  top: 365px;
  right: 25px;
`

export const LoginTitleContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings[7]};
`

export const Spacer = styled.div`
  height: ${({ theme }) => theme.spacings[3]};
`
